// For legacy block support
// import 'slick-carousel';
// import initFeatherlight from 'featherlight'
// initFeatherlight();
import './legacy-blocks';

import './blog';
import './navigation';
import './responsive-spacers';
import './search';
import './fslightbox-3.6.0';
import htmx from 'htmx.org';
import Splide from '@splidejs/splide';

htmx.config.globalViewTransitions = true;

jQuery(function($) {

    $('.wp-block-icb-icb103-category-tabs ul.tabs-nav-hover').each(function(){
		// For each set of tabs, we want to keep track of
		// which tab is active and its associated content
		var $active, $content, $links = $(this).find('a');
		var $container = $(this).closest('.wp-block-icb-icb103-category-tabs').find('.tabs-contents-wrap.desktop');
		
		// Find the tallest content height
		var maxHeight = 0;
		$links.each(function() {
			var contentHeight = $(this.hash).outerHeight();
			maxHeight = Math.max(maxHeight, contentHeight);
		});
		
		// Set the container height
		$container.css('height', maxHeight + 'px');
		
		// If the location.hash matches one of the links, use that as the active tab.
		// If no match is found, use the first link as the initial active tab.
		$active = $($links.filter('[href="'+location.hash+'"]')[0] || $links[0]);
		$active.addClass('active');
		
		$content = $($active[0].hash);
		
		// Initially hide all content except the first one
		$links.each(function() {
			if (!$(this).is($links.first())) {
				$(this.hash).addClass('hide');
			}
		});
		
		// Bind the mouseover event handler
		$(this).on('mouseover', 'a', function(e) {
			// Make the old tab inactive
			$active.removeClass('active');
			
			// Update the variables with the new link and content
			$active = $(this);
			$content = $(this.hash);
			
			// Make the tab active
			$active.addClass('active');
			
			// Remove hide class from current content
			$content.removeClass('hide');
			
			// Add hide class to all other content
			$links.each(function() {
				if (!$(this).is($active)) {
					$(this.hash).addClass('hide');
				}
			});
			
			// Prevent the anchor's default click action
			e.preventDefault();
		});

        // Go to URL on click
        $(this).on('click', 'a', function(e) {
            window.location.href = $(this).find('.large-link').attr('data-url');
            e.preventDefault();
        });
	});

})

document.addEventListener('DOMContentLoaded', function () {
    // Do stuff

    var splide = new Splide( '.featured-splide', {
        direction: 'ltr',
        type: 'loop',
        // height   : '10rem',
        wheel: false,
        releaseWheel: false,
        pagination: false,
        arrows: true,
        speed: 800,
        perPage: 4,
        perMove: 1,
        easing: 'cubic-bezier(0.26, 0.54, 0.32, 1)',
        breakpoints: {
            1024: {
                destroy: true,
            },
        }
    } );
    splide.mount();


    const carousels = document.querySelectorAll('.wp-block-icb-icb103-category-tabs .tabs-contents-wrap .splide');
    carousels.forEach((carouselEl) => {
    new Splide(carouselEl, {
        type: 'loop',
        arrows: true,
        pagination: false,
        autoplay: false,
        pauseOnHover: true,
        interval: 8000,
        autoHeight: true,
        width: '100%',
    }).mount();
    });

});
